import { Grid } from "@mui/material";
import React from "react";
import ClearanceTable from "./home/table";
import ClearanceHeader from "./home/header";

const Clearance = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <ClearanceHeader />
      </Grid>
      <Grid item xs={12}>
        <ClearanceTable />
      </Grid>
    </Grid>
  );
};

export default Clearance;
